import { useQueries } from '@tanstack/react-query';
import {
  toApiError,
  useApi,
  type ArrivalStepPreviewResponse,
  type ArrivalStepResponse,
} from '@/shared/api';
import { toArrivalDraft, toUpsertRequest } from './arrivalDraft';
import type { ArrivalScope } from './useArrivalGuideApi';

/**
 * Jeder Schritt so, wie ihn der Gast bekommt: vom Server gerendert, für ein Apartment und eine
 * Sprache. Codes bleiben dabei verdeckt — sie gehören einer Buchung, nicht dem Apartment.
 */
export function useArrivalGuidePreview(
  scope: ArrivalScope,
  steps: ArrivalStepResponse[],
  propertyId: string | null,
  locale: 'de' | 'en',
) {
  const api = useApi();
  return useQueries({
    queries: steps.map((step) => {
      const body = toUpsertRequest(toArrivalDraft(step));
      return {
        queryKey: [
          'arrival-steps',
          'preview',
          scope.kind,
          scope.id,
          JSON.stringify(body),
          propertyId,
          locale,
        ],
        queryFn: async (): Promise<ArrivalStepPreviewResponse> => {
          const request = { ...body, previewPropertyId: propertyId, locale };
          try {
            return await (scope.kind === 'object'
              ? api.arrivalSteps.previewForObject(scope.id, request)
              : api.arrivalSteps.previewForApartment(scope.id, request));
          } catch (error) {
            // Als ApiError, damit die Vorschau einen deutschen Grund nennen kann.
            throw await toApiError(error);
          }
        },
        staleTime: 30_000,
      };
    }),
  });
}
